import React from 'react';
import './header.css';
import { Button, Stack } from '@chakra-ui/react'
import { ArrowForwardIcon } from '@chakra-ui/icons'
// import {Link } from "react-router-dom";


const Header = () => {
    return (
        <div className='iconta__header section__padding' id='home'>
            
            <div className='iconta__header-content'>
            <h1 className='title'>
                Noi ne ocupăm de cifre <br />
                Tu conduci o afacere
            </h1>
            <p>
                I-CONTA îți oferă, pe lângă serviciile de consultanță fiscală și contabilitate, o nouă experiență în ceea ce privește
                relaționarea contabil - antreprenor <br /> <br />

                Aici poți avea acces oricând, oriunde, la situațiile tale financiar-contabile, poți încărca documente, poți calcula 
                singur, mult mai ușor taxele <br /> <br />

                Solicită acum o ofertă personalizată pentru a putea beneficia de toate acestea! 
            </p>

            <div className='iconta__header-content__input'>
            
                    <Stack direction='row' spacing={4}>
            <Button rightIcon={<ArrowForwardIcon />} colorScheme='teal' variant='outline' href='#form'>
                <a href='#form'>Vreau oferta</a>
                        </Button>
                        </Stack> 
                        
                    
            </div>
            </div>
            
            </div>
    )
}

export default Header
